'use strict';

function companyFactory (apiFactory, $rootScope, Common, $timeout, addressCalculationFactory, postalCodesFactory) {
  const form = Common.get('companyCache', {});

  function getForm () {
    return form;
  }

  function getData (type) {
    if (type === 'activity') return apiFactory.getActivity.get().$promise;
    if (type === 'employments') return apiFactory.getEmployments.get().$promise;
    if (type === 'turnover') return apiFactory.getIncomeRange.query().$promise;
    if (type === 'numberOfEmployees') return apiFactory.getEmployeeRange.query().$promise;
  }

  function constructRequest () {
    const req = {
      mainActivity: getValueFromCheckbox(form.activity),
      employmentMainPosition: getValueFromCheckbox(form.employments),
      numberOfEmployees: getValueFromSlider(form.numberOfEmployees),
      companyTurnover: getValueFromSlider(form.turnover)
    };

    return req;
  }

  function getValueFromCheckbox (checkbox) {
    function extractCodes (nodes, result) {
      result = result || [];
      for (let i = 0, length = nodes.length; i < length; i++) {
        const node = nodes[i];
        if (node.state === 'checked') {
          result.push(node.code);
        } else if (node.state === 'indeterminate' && node.children) {
          result = extractCodes(node.children, result);
        }
      }
      return result;
    }

    if (angular.isUndefined(checkbox)) {
      return undefined;
    }

    const clone = _.cloneDeep(checkbox);

    const filtered = clone.filter(function f (o) {
      if (o.state === 'checked') {
        delete o.children;
        return true;
      } else if (angular.isDefined(o.children) && o.state === 'indeterminate') {
        return (o.children = o.children.filter(f)).length;
      }
      return false;
    });

    const codes = extractCodes(filtered);

    if (codes.length === 0) {
      return undefined;
    }

    const joined = codes.join(',');

    return joined;
  }

  function getValueFromSlider (item) {
    const range = slider().getRange(item);
    if (item && range && range.length !== 0) {
      return range.join(',');
    }
    return undefined;
  }

  function checkbox () {
    function construct (checkboxType) {
      return new Promise(function (resolve, reject) {
        const cache = Common.get('companyCache.' + checkboxType);
        if (cache) {
          enrich(cache);
          form[checkboxType] = cache;
          return resolve();
        } else {
          getData(checkboxType)
            .then(function (data) {
              const checkboxes = data.nodes;
              enrich(checkboxes);
              form[checkboxType] = checkboxes;
              return resolve();
            })
            .catch(function (reason) {
              console.error(reason);
              reject(reason);
            });
        }
      });
    }

    function check (node, preferredState) {
      const oldState = node.state;
      let stateToSet = preferredState || null;

      if (oldState === 'unchecked') {
        stateToSet = 'checked';
      } else if (oldState === 'checked' || oldState === 'indeterminate') {
        stateToSet = 'unchecked';
      }

      node.state = stateToSet; // apply our new state on clicked node
      setChildren(node, stateToSet); // set all children to an equal state
      setParents(node, stateToSet); // calculate parents new state

      if (postalCodesFactory.zipcodes.length) {
        save();
        addressCalculationFactory.computeRefinedCount(constructRequest());
      }
    }

    // update checkbox.state for all parents of node
    function setParents (node, state) {
      const parent = node._parent;
      if (parent) { // check if we can climb
        let stateToSet = state; // first, set to preferred state
        for (const sibling of parent.children) {
          // check if any of the siblings have a different state
          if (sibling.state !== state) {
            // if they do, set to indeterminate
            stateToSet = 'indeterminate';
          }
        }
        parent.state = stateToSet;
        setParents(parent, state); // climb up in the tree
      }
    }

    // update checkbox.state for all children of node
    function setChildren (node, state) {
      if (node.children) {
        for (const child of node.children) {
          child.state = state;
          setChildren(child, state); // climb down in the tree
        }
      }
    }

    // function that adds defaults and parent reference in an array of nodes
    function enrich (nodes, parent) {
      for (const node of nodes) {
        node._parent = parent;
        node.state = node.state || 'unchecked';
        node.expanded = node.expanded || false;
        if (node.children) {
          enrich(node.children, node);
        }
      }
    }

    return {
      construct,
      check
    };
  }

  function slider () {

    function construct (sliderType, onEnd) {
      return new Promise(function (resolve, reject) {
        const cache = Common.get('companyCache.' + sliderType);
        if (cache) {
          cache.options.onEnd = onEnd; // we need to add this again when cached, functions are not saved in session storage
          form[sliderType] = cache;
          resolve();
        } else {
          getData(sliderType)
            .then(function (data) {
              const stepsArray = [];

              data.forEach(function (step) {
                stepsArray.push({
                  value: step.range,
                  code: step.code
                });
              });

              const slider = {
                min: 0,
                max: stepsArray.length - 1,
                options: {
                  stepsArray,
                  showTicks: true,
                  mergeRangeLabelsIfSame: true,
                  bindIndexForStepsArray: true,
                  onEnd
                }
              };

              form[sliderType] = slider;

              return resolve();
            })
            .catch(function (reason) {
              console.error(reason);
              reject(reason);
            });
        }
      });
    }

    function getRange (slider) {
      if (!slider) return undefined;
      const min = slider.min;
      const max = slider.max;
      const array = slider.options.stepsArray;
      const range = [];

      if (slider.min === 0 && slider.max === array.length - 1) {
        return;
      }

      for (let i = min; max >= i; i++) {
        range.push(array[i].code);
      }

      return range;
    }

    return {
      construct,
      getRange
    };
  }

  function save () {
    function removeParents (nodes) {
      for (const node of nodes) {
        delete node._parent;
        if (node.children) {
          removeParents(node.children);
        }
      }
    }

    // shallow clone so we don't muck with existing properties
    const activity = _.cloneDeep(form.activity);
    const employments = _.cloneDeep(form.employments);

    // sanetize so we don't get circular reference when saving
    removeParents(activity);
    removeParents(employments);

    const cache = {
      zipcodes: addressCalculationFactory.zipcodes,
      employments,
      activity,
      turnover: form.turnover,
      numberOfEmployees: form.numberOfEmployees
    };

    Common.set('companyCache', cache);
  }

  const factory = {
    constructRequest,
    save,
    checkbox: checkbox(),
    slider: slider(),
    form: getForm()
  };

  return factory;
}

angular.module('web2print.recipients')
  .factory('companyFactory', companyFactory);
